import { Copy } from 'lucide-react'
import { Button } from 'components/ds2'
import { TelegramSetupStepItem } from './TelegramSetupStepItem'

interface TelegramSetupInstructionsProps {
    isConfigured: boolean
    telegramLink: string
    formattedTelUsername: string
    connectCommand: string
    copiedField: 'command' | 'bot' | null
    withTourTags: boolean
    onCopy: (value: string, field: 'command' | 'bot') => void
}

export const TelegramSetupInstructions = ({
    isConfigured,
    telegramLink,
    formattedTelUsername,
    connectCommand,
    copiedField,
    withTourTags,
    onCopy,
}: TelegramSetupInstructionsProps) => (
    <div className="mt-3 rounded-xl bg-surface-secondary p-3">
        <h5 className="mb-3 text-sm font-semibold text-foreground">Connect Telegram</h5>
        <ol className="space-y-4">
            <TelegramSetupStepItem number={1} title="Add the bot to the driver’s Telegram group">
                <div className="mt-1.5 flex flex-wrap items-center gap-2">
                    {isConfigured && telegramLink ? (
                        <a href={telegramLink} target="_blank" rel="noreferrer" className="break-all font-semibold text-accent hover:underline">
                            {formattedTelUsername}
                        </a>
                    ) : (
                        <p role="status" className="text-foreground-muted">
                            Bot username unavailable. Ask your administrator to configure Telegram.
                        </p>
                    )}
                    <Button
                        variant="outline"
                        size="sm"
                        prefix={<Copy className="h-3.5 w-3.5" />}
                        disabled={!isConfigured}
                        onClick={() => onCopy(formattedTelUsername, 'bot')}
                    >
                        {copiedField === 'bot' ? 'Copied' : 'Copy bot name'}
                    </Button>
                </div>
            </TelegramSetupStepItem>
            <TelegramSetupStepItem number={2} title="Send the connect command in that group">
                <div className="mt-1.5 space-y-2" {...(withTourTags ? { 'data-tour': 'telegram-copy-command' } : {})}>
                    {connectCommand ? (
                        <code className="block break-all rounded-lg bg-surface px-2 py-1.5 text-xs text-foreground">{connectCommand}</code>
                    ) : (
                        <p className="text-foreground-muted">Save the driver first to generate the command.</p>
                    )}
                    <Button
                        variant="outline"
                        size="sm"
                        prefix={<Copy className="h-3.5 w-3.5" />}
                        disabled={!connectCommand}
                        onClick={() => onCopy(connectCommand, 'command')}
                    >
                        {copiedField === 'command' ? 'Copied' : 'Copy command'}
                    </Button>
                </div>
            </TelegramSetupStepItem>
            <TelegramSetupStepItem number={3} title="Check the connection">
                The Telegram status changes to Connected when the bot links the group.
            </TelegramSetupStepItem>
        </ol>
    </div>
)
